module.exports = __webpack_public_path__ + "static/img/wait.d3f598a.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/wait.png
// module id = 9sg8
// module chunks = 1